"use strict";

require("./_inline-svg");